import axios, { AxiosRequestConfig } from 'axios'
import { errorMsg, handleCommonError, handleNoCommontError } from './errorHandle'
import qs from 'qs'





const baseUrl = ''

export const RESOURCE_URL = 'http://zhixue.lxnews.cn/'

// 拦截器
axios.interceptors.response.use(
	// 响应拦截
  response => {
		// toogleLoading(false)
		return response.data
	},
	// 错误拦截
	error => {
		const { response } = error
		// toogleLoading(false)
		// 请求有响应
		if (response) {

			const { status, data, config } = response
			const { message } = data
			if (status === 400 || status === 401 ) {
				handleCommonError(data, config)
				return Promise.reject(message)
			}
			handleNoCommontError(errorMsg)
			return Promise.reject(errorMsg)
		}
		// 请求超时
		if (error.code === 408) {
			const timeoutMsg = '请求超时，请稍后再试'
			handleNoCommontError(timeoutMsg)
			return Promise.reject(timeoutMsg)
		}

		const networkErrorMsg = '您的网络出现问题，请检查网络重试'
		handleNoCommontError(networkErrorMsg)
		return Promise.reject(networkErrorMsg)
	}
)

// request
export default async function request(options) {
	const { url } = options
	delete options.url

	let headers = {}
	if (options) {
		headers = options.headers || {}
	}

	const defaultOptions = {
		headers: {
			...headers
		},
		credentials: 'include',
		timeout: 10000,
		withCredentials: true,
		validateStatus(status) {
			return status >= 200 && status < 300
		}
	}
	if (options) {
		delete options.headers
	}
	const newOptions = { ...defaultOptions, ...options }

	newOptions.data = newOptions.body
	if (newOptions.method === 'get') {
		newOptions.paramsSerializer = params => {
			return qs.stringify(params, { arrayFormat: 'repeat' })
		}
	}
	delete newOptions.body
	// toogleLoading(true)
	const newUrl = baseUrl + url

	return axios(newUrl, newOptions)
}
